import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { UserRoleTablePopupsTypes, UserTablePopupsTypes } from "./PopupTypes";
import { CloseIcon, SearchIcon } from "../iconSet/IconSet";
import { UsersTypes } from "../../Data";
import DataTable from "react-data-table-component";
import { customStyles } from "./CustomDataTableStyles";
import TableNoData from "../tablePartComp/TableNoData";
import TableTitle from "../tablePartComp/TableTitle";
import UserDataTable from "./UserDataTable";
import UserRoleDateTable, { UserRoleDataRowType } from "./UserRoleDataTable";
import { getToken } from "../../services/APITemplateService";

const userColumns = [
	//{name: 'ID', selector: (row: UsersTypes) => row.id},
	{ name: "Username", selector: (row: UsersTypes) => row.username },
	{ name: "Department", selector: (row: UsersTypes) => row.department },
];

type RoleType = {
	roleid: string;
	rolename: string;
	roledescription: string;
	roleAreaSpecificity: string;
}

const RecipientRoleTablePopup = (props: UserRoleTablePopupsTypes) => {
	const BASE_URL = process.env.REACT_APP_BASE_URL

	const [selectedRows, setSelectedRows] = useState<UserRoleDataRowType[]>([])

	const [userRoles, setUserRoles] = React.useState<UserRoleDataRowType[]>([]);

	const [isTableLoading, setIsTableLoading] = useState<boolean>(false)

	const getAllRoles = async () => {
		setIsTableLoading(true)
		const URL: string = `${BASE_URL}/identity_manager/api/v1/getallroles`
		const HEADER: RequestInit = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${getToken()}`
			}
		}

		try
		{
			const response = await fetch(URL, HEADER);
			const responseData = await response.json() as RoleType[]

			if (!response.ok)
			{
				console.error(`Failed to fetch roles: ${response.status} ${response.statusText}`);
      			return null;
			}

			const roleData: UserRoleDataRowType[] = []
			responseData.map(item => {
				roleData.push({id: item.roleid, name: item.rolename, description: item.roledescription, areaSpecificity: item.roleAreaSpecificity})
			})
			setUserRoles(roleData)
		}
		catch (error)
		{
			console.error("Error fetching roles:", error);
    		return null;
		}
		setIsTableLoading(false)
	}

	useEffect(() => {
		//console.log("USER ROLE:", userRoles)
	}, [userRoles])

	const handleAddClick = useCallback(() => {
		//props.selectedRows(selectedRows)
		if (props.function) {
			props.function(selectedRows);
		}

		props.setWindowState(false);
	}, [selectedRows]);

	useEffect(() => {
		getAllRoles()
	}, [])

	return (
		<div className={`workflow-popup`}>
			<div className={`workflow-popup-wrapper`}>
				<div className={`title`}>
					<span>{props.title}</span>
					<CloseIcon
						width="1.2rem"
						color="var(--color-main-red)"
						onClick={(e) => props.setWindowState(false)}
					/>
				</div>
				<div className={`data-wrapper`}>
					<UserRoleDateTable data={userRoles} setSelectedRows={setSelectedRows} isLoading={isTableLoading}/>
					{/* <div className={`search-box-wrapper`}>
						<div className={`input-wrapper`}>
							<i>
								<SearchIcon color="var(--color-main-white)" width="1.2rem" />
							</i>
							<input
								type="text"
								placeholder="Search"
								onChange={(e) => handleSearch(e)}
							/>
						</div>
					</div>
					<div className={`table-box`}>
						<DataTable
							title={<TableTitle title="select users"/>}
							columns={userColumns}
							data={filterText ? filteredData : users}
							customStyles={customStyles}
							onSelectedRowsChange={handleSelectRow}
							pagination
							paginationPerPage={5}
							paginationRowsPerPageOptions={[5, 10, 15]}
							selectableRows
							highlightOnHover
							noDataComponent={<TableNoData />}
						/>
					</div> */}
					<div className={`button-wrapper`} style={{ gridArea: "buttons" }}>
						<div className={`left-side`}></div>
						<div className={`right-side`}>
							<button className={`button-normal`} onClick={handleAddClick}>
								add
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RecipientRoleTablePopup;